import { render } from "./Triple.vue?vue&type=template&id=15a0c7a5&scoped=true&ts=true"
import script from "./Triple.vue?vue&type=script&lang=ts"
export * from "./Triple.vue?vue&type=script&lang=ts"

import "./Triple.vue?vue&type=style&index=0&id=15a0c7a5&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a0c7a5"]])

export default __exports__